<template>
    <div>
        <badge variant="default" v-if="status === 'pending'">Pending</badge>
        <badge variant="warning" v-if="status === 'waiting'">Waiting</badge>
        <badge variant="success" v-if="status === 'running'">Running</badge>
        <badge variant="danger" v-if="status === 'error'">Error</badge>
        <badge variant="success" v-if="status === 'completed'">Completed</badge>
        <badge variant="danger" v-if="status === 'stopped'">Stopped</badge>
    </div>
</template>

<script>
export default {
    props: ['status'],
}
</script>
